var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCart6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4485 20.75C18.2769 20.75 18.9485 20.0784 18.9485 19.25C18.9485 18.4216 18.2769 17.75 17.4485 17.75C16.62 17.75 15.9485 18.4216 15.9485 19.25C15.9485 20.0784 16.62 20.75 17.4485 20.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44847 20.75C10.2769 20.75 10.9485 20.0784 10.9485 19.25C10.9485 18.4216 10.2769 17.75 9.44847 17.75C8.62004 17.75 7.94847 18.4216 7.94847 19.25C7.94847 20.0784 8.62004 20.75 9.44847 20.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6685 8.96L21.0885 14.51C20.7485 15.68 19.6585 16.5 18.4385 16.5H8.58848C7.27848 16.5 6.14848 15.57 5.88848 14.29L4.43848 7.04C4.34848 6.6 4.03848 6.24 3.60848 6.1L1.70848 5.47C1.31848 5.33 1.10848 4.91 1.23848 4.52C1.33848 4.21 1.63848 4 1.95848 4C2.02848 4 2.10848 4.01 2.18848 4.04L4.08848 4.68C5.01848 4.99 5.71848 5.78 5.90848 6.75L7.35848 14C7.47848 14.58 7.99848 15 8.58848 15H18.4385C18.9985 15 19.4885 14.63 19.6385 14.1L21.2285 8.55C21.3385 8.15 21.7585 7.92 22.1585 8.03C22.3485 8.09 22.5085 8.21 22.6085 8.39C22.6985 8.57 22.7285 8.77 22.6685 8.96Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9485 5.88V7C18.9485 7.62 18.4585 8.13 17.8485 8.13V12.63C17.8485 13.25 17.3585 13.75 16.7485 13.75H10.1485C9.53847 13.75 9.04847 13.25 9.04847 12.63V8.13C8.43847 8.13 7.94847 7.62 7.94847 7V5.88C7.94847 5.26 8.43847 4.75 9.04847 4.75H17.8485C18.4585 4.75 18.9485 5.26 18.9485 5.88Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart6);
export default __webpack_public_path__ + "static/media/shopping-cart-6.81437f6025f9820f0071021bc1da1034.svg";
export { ForwardRef as ReactComponent };